import React from 'react';
import { theme } from 'antd';

import DiagnosticsSummaryRow from './DiagnosticsSummaryRow';
import { CHECK_ROW_LABEL_BASIS } from './DiagnosticsCheckRowCard';
import { reportCardChrome } from './reportCardStyle';
import type { CheckRow } from '../diagnosticsReportUtils';

type DiagnosticsSummaryCardProps = {
  domain: string;
  url: string;
  blockedProviders: string[];
  checkRows: CheckRow[];
  crawlersTested: string[];
  print?: boolean;
  /** Rendered below the labelled cells, inside the same box (PRE-3190). */
  note?: React.ReactNode;
};

// The card box is drawn here rather than on the cells so the note can be a normal block
// element: prose inside the layout table would be announced in table-reading mode, and
// break-inside is ignored on table rows in Safari/WebKit (see DiagnosticsCheckRowCard).
// The cells stay a table only so the colgroup can line their columns up with the check
// cards below.
export default function DiagnosticsSummaryCard({
  domain,
  url,
  blockedProviders,
  checkRows,
  crawlersTested,
  print = false,
  note,
}: DiagnosticsSummaryCardProps) {
  const { token } = theme.useToken();

  return (
    <div
      className="diagnostics-summary-card"
      data-testid="diagnostics-summary-card"
      style={{ ...reportCardChrome(token), backgroundColor: token.colorBgContainer }}
    >
      <table style={{ width: '100%', borderSpacing: 0 }}>
        <colgroup>
          <col style={{ width: CHECK_ROW_LABEL_BASIS }} />
          <col />
          <col />
        </colgroup>
        <tbody>
          <DiagnosticsSummaryRow
            domain={domain}
            url={url}
            blockedProviders={blockedProviders}
            checkRows={checkRows}
            crawlersTested={crawlersTested}
            print={print}
          />
        </tbody>
      </table>

      {note && <div style={{ padding: `0 ${token.paddingMD}px ${token.paddingMD}px` }}>{note}</div>}
    </div>
  );
}
